/**
 * SiteFooter — client component
 *
 * Must be a client component because @nself-web/ui bundles hooks into its
 * dist without a "use client" directive. Marking this wrapper as client
 * satisfies RSC requirements until the ui package adds the directive.
 *
 * Renders the @nself-web/ui <Footer /> as the bottom chrome for
 * sentry.nself.org with sentry-specific link groups (the default groups are
 * nself.org's) — including the Legal set required at every footer:
 * /legal/terms, /legal/privacy, /legal/gdpr.
 * Uses the static default operational pill — no live fetch overhead.
 *
 * Named SiteFooter (not Footer) to avoid collision with the @nself-web/ui
 * Footer export.
 */
'use client'

import { Footer as UIFooter, type FooterLinkGroup } from '@nself-web/ui'

const LINK_GROUPS: FooterLinkGroup[] = [
  {
    title: 'Product',
    links: [
      { label: 'Features', href: '/features' },
      { label: 'Pricing', href: '/pricing' },
      { label: 'Demo', href: '/demo' },
      { label: 'Compare', href: '/compare' },
      { label: 'Changelog', href: '/changelog' },
    ],
  },
  {
    title: 'Get started',
    links: [
      { label: 'Sign up free', href: '/app/signup' },
      { label: 'Sign in', href: '/app/login' },
      { label: 'Self-host', href: '/self-host' },
      { label: 'Migrate', href: '/migrate' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Terms of Service', href: '/legal/terms' },
      { label: 'Privacy Policy', href: '/legal/privacy' },
      { label: 'GDPR & DPA', href: '/legal/gdpr' },
    ],
  },
  {
    title: 'ɳSelf',
    links: [
      { label: 'nself.org', href: 'https://nself.org', external: true },
      { label: 'Docs', href: 'https://docs.nself.org', external: true },
      { label: 'GitHub', href: 'https://github.com/nself-org', external: true },
    ],
  },
]

export function SiteFooter() {
  return <UIFooter logoHref="https://nself.org" linkGroups={LINK_GROUPS} />
}
